export const IS_IMAGE_MIME = 'image/';
export const DEFAULT_CHAT_ROOM_MSG =
  "Welcome to my Chat Room. Please share your own interesting content and make some new friends. Let's keep it clean and have some fun!";
export const WARNING_MESSAGE = {
  POST_AGE_ERROR:
    'Ability to submit a Post in the Chat Room is restricted to users over the age of 18',
  POST_COMMENT_AGE_ERROR:
    'Ability to submit Comments in the Chat Room is restricted to users over the age of 18'
};

export const MY_FORUM_CONSTANTS = {
  BUTTON_LABEL: 'Button Label',
  DEFAULT_BUTTON_LABEL: 'Chat Room',
  ADD_TOPIC: 'Add Topic',
  labels: {
    title: 'Title',
    description: 'Description',
    action: 'Action',
    enable: 'Enable',
    disable: 'Disable',
    edit: 'Edit',
    delete: 'Delete',
    confirm: 'Confirm',
    filterTopics: 'Filter Topics',
    selectAll: 'Select All',
    clear: 'Clear',
    apply: 'Apply',
    viewAll: 'View All'
  }
} as const;

export const getChatRoomCtaLabel = (cta?: string | null): string =>
  cta?.trim() || MY_FORUM_CONSTANTS.DEFAULT_BUTTON_LABEL;

export const getChatRoomUiLabels = (cta?: string | null) => {
  const label = getChatRoomCtaLabel(cta);
  return {
    label,
    myTitle: `My ${label}`,
    someoneTitle: (name: string) => `${name}'s ${label}`,
    members: `${label} Members`,
    noMembers: `There are no active Members in the ${label}`,
    createDiscussion: `Create New ${label} Discussion`,
    editDiscussion: `Edit ${label} Discussion`,
    discussions: `${label} Discussions`,
    topics: `${label} Topics`,
    noDiscussions: `There are not any ${label} Discussions yet. Start the conversation!`,
    noTopicsYet: `There are no ${label} Topics created yet.`,
    bannerAlt: `${label} Banner`,
    tellWhatsOnMind: `Tell the ${label} what's on your mind today...`,
    settings: `My ${label} Settings`,
    owner: `${label} Owner`
  };
};
